import { useEffect } from 'react';
import { pick, prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getCleanPath } from 'js/utils/url.util';
import { useAppSelector, useLottoSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useLottoFetch = () => {
    const dispatch = useDispatch();
    const {
        globalLottoScriptPromise,
        globalLottoScriptRequestPromise
    } = window;
    const { pathname } = useLocation();
    const lottoRootURL = useAppSelector(prop('lottoRootURL'));
    const {
        isNeedToStart,
        isAppInitialized,
        isIntegrationScriptFetched,
        isIntegrationScriptFetching,
        isIntegrationScriptError
    } = useLottoSelector(pick([
        'isNeedToStart',
        'isAppInitialized',
        'isIntegrationScriptFetched',
        'isIntegrationScriptFetching',
        'isIntegrationScriptError'
    ]));

    useEffect(() => {
        if (isNeedToStart || !lottoRootURL) {
            return;
        }

        const lottoPageRegExp = new RegExp(`(^${lottoRootURL}$)|(^${lottoRootURL}/)`);
        const isLottoPage = lottoPageRegExp.test(getCleanPath(pathname));

        if (isLottoPage && !isAppInitialized) {
            dispatch(actions.startIntegration());
        }
    }, [isNeedToStart, dispatch, isAppInitialized, pathname, lottoRootURL]);

    useEffect(() => {
        if (!isNeedToStart || isIntegrationScriptFetched || isIntegrationScriptFetching || isIntegrationScriptError) {
            return;
        }

        dispatch(actions.setIntegrationScriptFetching());

        const promise = globalLottoScriptPromise ?? globalLottoScriptRequestPromise?.();

        if (promise instanceof Promise) {
            promise
                .then(() => dispatch(actions.setIntegrationScriptFetched()))
                .catch(() => dispatch(actions.setIntegrationScriptError()));

            return;
        }

        dispatch(actions.setIntegrationScriptError());
    }, [
        dispatch,
        globalLottoScriptPromise,
        globalLottoScriptRequestPromise,
        isIntegrationScriptError,
        isIntegrationScriptFetched,
        isIntegrationScriptFetching,
        isNeedToStart
    ]);
};
